// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__QGinM","choiceBoxes":"toolbarselects_choiceBoxes__2afoh","simpleField":"toolbarselects_simpleField__2VPeH"};